import React, {useContext} from 'react';
import {Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, Radio, RadioGroup} from "@mui/material";
import Typography from "@mui/material/Typography";
import {Controller} from "react-hook-form";
import {isEmpty} from "../../../utils/GenericUtils";
import {getHelperStyle} from "../../../styles/components/FormStyle";
import {MonitorStyle} from "../../../styles/pages/monitor/MonitorStyle";
import {AppContext} from "../../../App";
import {languages} from "../../../strings/LanguageDictionary";
import {useTheme} from "@mui/material/styles";


export const QuestionWithMultipleOption = ({
	                                           question,
	                                           subQuestion,
	                                           control,
	                                           name,
	                                           autoFocus,
	                                           error = {},
	                                           rules = {},
	                                           defaultValue,
	                                           disabled = false,
	                                           answers,
	                                           row = true,
	                                           multiple = false
                                           }) => {
	
	const classes = MonitorStyle();
	const appContext = useContext(AppContext);
	let theme = useTheme();
	
	return (
		<React.Fragment>
			
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Typography variant={"subtitle1"}>
						<b>{question}</b>
						{
							subQuestion && <React.Fragment>
								<br/>
								<span style={{color: theme.palette.text.secondary, paddingLeft: 20}}>{subQuestion}</span>
							</React.Fragment>
						}
					</Typography>
					<FormControl variant={"outlined"} disabled={disabled} required={rules && rules.required}
					             className={classes.subQuestionRadio}>
						{
							multiple ?
								answers.map(answer => {
									return (<FormControlLabel
										key={answer.label}
										label={
											<React.Fragment>
												<Typography>
													{answer.label}
												</Typography>
												<Typography color={"textSecondary"} variant={"body2"}>
													{answer?.info}
												</Typography>
											</React.Fragment>
										}
										control={
											<Controller
												name={answer.name}
												control={control}
												defaultValue={false}
												render={(props) => (
													<Checkbox
														{...props}
														checked={props.value}
														onChange={(e) => {
															props.onChange(e.target.checked)
														}}
													/>
												)}
											/>
										}
									/>)
								}) :
								<Controller
									render={({onChange, value}) => (
										<RadioGroup autoFocus={autoFocus} value={value} onChange={onChange} row={row}>
											{
												answers.map(answer => {
													return (<FormControlLabel
														key={answer.label}
														control={<Radio/>}
														label={
															<React.Fragment>
																<Typography>
																	{answer.label}
																</Typography>
																<Typography color={"textSecondary"} variant={"body2"}>
																	{answer?.info}
																</Typography>
															</React.Fragment>
														}
														value={answer.value}
													/>)
												})
											}
										</RadioGroup>)}
									name={name}
									control={control}
									defaultValue={defaultValue}
									rules={rules}
								/>
						}
						{!isEmpty(error) && <FormHelperText
							style={getHelperStyle().helperRadio}>{languages[appContext.state.lang].OCEAN__GLOBAL_REQUIRED_FILES_}</FormHelperText>
						}
					</FormControl>
				</Grid>
			</Grid>
		</React.Fragment>
	);
};
